module.exports = __webpack_public_path__ + "static/media/dashboard.70ad11e2.png";